"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var idm_classifier_service_client_js_1 = require("@synisys/idm-classifier-service-client-js");
var idm_authentication_client_js_1 = require("@synisys/idm-authentication-client-js");
var disaggregation_util_1 = require("./util/disaggregation.util");
var path_util_1 = require("./util/path.util");
var operators_1 = require("rxjs/operators");
/**
 * @author gevorg.avetisyan on 2/15/2017.
 */
var MEDisaggregation = /** @class */ (function () {
    function MEDisaggregation(http, classifierService) {
        this.http = http;
        this.classifierService = classifierService;
        this.disaggregationDates = new Map();
    }
    MEDisaggregation.prototype.getDisaggregation = function (systemName) {
        return this.http.get(path_util_1.PathUtil.PATH + systemName + ".json").pipe(operators_1.map(function (res) {
            var classifier = [];
            for (var _i = 0, res_1 = res; _i < res_1.length; _i++) {
                var item = res_1[_i];
                classifier.push(disaggregation_util_1.DisaggregationUtil.createClassifierDummy(item["id"], item["name"]));
            }
            return classifier;
        }));
    };
    MEDisaggregation.prototype.getDisaggregationMeta = function (id) {
        return this.http.get(path_util_1.PathUtil.PATH + id + ".json");
    };
    MEDisaggregation.prototype.getDisaggregationBySystemName = function (systemName) {
        return this.disaggregationDates.get(systemName);
    };
    MEDisaggregation.prototype.getDisaggregationFromService = function (systemName) {
        //this.disaggregationService.getDisaggregation(systemName)
    };
    /**
     * Method return DisaggregationTypes
     * @param {string} categoryName
     * @returns {Observable<Array<Classifier>>}
     */
    MEDisaggregation.prototype.getDisaggregationTypes = function (categoryName) {
        return this.classifierService.loadClassifiers(categoryName).pipe(operators_1.map(function (res) { return res.getData(); }));
    };
    MEDisaggregation.prototype.getDisaggregationTypesView = function (categoryName) {
        return this.classifierService.loadClassifiersView(categoryName);
    };
    MEDisaggregation.prototype.getDisaggregationTypesByParentId = function (categoryName, parentId) {
        return this.classifierService.loadClassifiersByParent(categoryName, parentId).pipe(operators_1.map(function (res) { return res.getData(); }));
    };
    MEDisaggregation = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [idm_authentication_client_js_1.HttpClientWrapper,
            idm_classifier_service_client_js_1.ClassifierService])
    ], MEDisaggregation);
    return MEDisaggregation;
}());
exports.MEDisaggregation = MEDisaggregation;
//# sourceMappingURL=disaggregation.service.js.map